import React from 'react';
import { Languages } from 'lucide-react';
import { useContent } from '../contexts/ContentContext';

const LanguageSwitcher: React.FC = () => {
    const { t, toggleLanguage } = useContent();

    return (
        <button
            onClick={toggleLanguage}
            type="button"
            className="inline-flex items-center gap-1 p-2 rounded-md text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100 ivory:text-coffee-600 ivory:hover:text-coffee-800 focus:outline-none font-bold text-sm"
            aria-label={`${t('common.language')} (${t('common.languageName')})`}
        >
            <Languages size={20} aria-hidden="true" />
            {t('common.languageCode')}
        </button>
    );
};

export default LanguageSwitcher;
